import Controller from "./reports.controller";
import template from "./reports.html";

const reports = {
  template,
  controller: Controller,
};

export default reports;



// WEBPACK FOOTER //
// ./src/pages/reports/reports.component.js